import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import CrossIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CrossIconPath";
import TaskState from "@coworker/apprestructured/src/task-management/types/TaskState";
import ViewerTop from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/ViewerTop/ViewerTop";
import Texts from "@coworker/apprestructured/src/task-management/components/SheetTop/Texts/Texts";
import Subtitle from "@coworker/apprestructured/src/task-management/components/SheetTop/Subtitle/Subtitle";
import Title from "@coworker/apprestructured/src/task-management/components/SheetTop/Title/Title";
import CloseButtonWrapper from "@coworker/apprestructured/src/task-management/components/SheetTop/CloseButtonWrapper/CloseButtonWrapper";
import Badge from "@coworker/apprestructured/src/task-management/components/SheetTop/Badge/Badge";

type TitledViewerTopProps = {
  title: string;
  subtitle: string;
  onCloseButtonClick: () => void;
  state: TaskState;
  onMenuButtonClick: () => void;
  badge: string | null;
};

function TitledViewerTop({
  title,
  subtitle,
  onCloseButtonClick,
  state,
  onMenuButtonClick,
  badge,
}: TitledViewerTopProps) {
  return (
    <ViewerTop state={state}>
      <CloseButtonWrapper>
        <FixaButton
          onClick={onCloseButtonClick}
          ssrIcon={CrossIconPath}
          iconOnly
          type="tertiary"
          inverseTheme
          size="small"
        />
      </CloseButtonWrapper>
      <Texts>
        {badge !== null && <Badge text={badge} />}
        <Title light onMenuButtonClick={onMenuButtonClick}>
          {title}
        </Title>
        <Subtitle light>{subtitle}</Subtitle>
      </Texts>
    </ViewerTop>
  );
}

export default TitledViewerTop;
